import { Configuration, LogLevel } from '@azure/msal-browser';
import { validateEnvironment } from '../types/env';
import { LoginRequest } from '../types';
import { getDynamicRedirectUri, getDynamicPostLogoutRedirectUri, validateAllowedDomain } from '../utils/authUtils';
import { DEFAULT_URLS } from './defaults';

// Validate environment variables on startup
validateEnvironment();

// Optional: Define allowed domains for security (remove if you want to allow any domain)
const ALLOWED_DOMAINS = [
  'https://aieap.coint.ai',
  'https://aieap-preview.coint.ai',
  'https://kim.renewmyday.com',
  'https://kim-preview.renewmyday.com',
  'http://localhost:3000',
  'http://localhost:3001',
  'https://localhost:3000',
  'capacitor://localhost',
  'https://app.renewmyday.com'
];

// Validate current domain against allowed list
if (!validateAllowedDomain(ALLOWED_DOMAINS)) {
  throw new Error('Application is being accessed from an unauthorized domain');
}

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: process.env.REACT_APP_AZURE_AUTHORITY || `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANT_ID}`,
    redirectUri: getDynamicRedirectUri(),
    postLogoutRedirectUri: getDynamicPostLogoutRedirectUri(),
    navigateToLoginRequestUrl: false // Prevent double redirects
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
    secureCookies: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        
        // Filter out specific MSAL warnings about multiple instances during development
        if (message.includes('There is already an instance of MSAL.js in the window')) {
          // Suppress this warning during development
          return;
        }
        
        // Only log warnings and errors to reduce console noise
        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL]', message);
            return;
          case LogLevel.Warning:
            console.warn('[MSAL]', message);
            return;
          case LogLevel.Info:
          case LogLevel.Verbose:
          default:
            // Suppress Info and Verbose logs
            return;
        }
      },
      // Set minimum log level to Warning to reduce verbosity
      logLevel: LogLevel.Warning
    }
  }
};

export const loginRequest: LoginRequest = {
  scopes: ['openid', 'profile', 'email'],
  domainHint: 'renewmyday.com'
};

export const apiRequest = {
  scopes: [process.env.REACT_APP_BACKEND_API_URL_SCOPE || 'api://deb17aec-3784-4c34-817e-82ef3a56ecd4/.default']
};

export const graphConfig = {
  graphMeEndpoint: DEFAULT_URLS.GRAPH_ME_ENDPOINT
};
